import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const bond = defineConnector({
  identifier: "bond",
  name: "Bond",
  tagLine: "Smart control for fans, fireplaces, and shades",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ deviceUrl }) =>
    urlToPattern(`${deviceUrl || "http://bond.local"}/v2`),
  auth: (app) => headerAuth([{ name: "BOND-Token", value: app.secret.token }]),
  steps: [
    {
      title: "Find your Bond local token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Bond Home app, open your Bond Bridge’s device settings to find its local token. You’ll also need the bridge’s IP address on your network.",
        },
      ],
    },
    {
      title: "Enter your Bond Bridge details",
      items: [
        {
          kind: "baseUrl",
          label: "Bond Bridge URL",
          placeholder: "http://192.168.1.10",
          required: true,
          helperText: "The http URL for your Bond Bridge on the local network.",
          target: { kind: "configuration", field: "deviceUrl" },
        },
        {
          kind: "input",
          label: "Local token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ deviceUrl }) =>
      `${deviceUrl || "http://bond.local"}/v2/devices`,
  },
});
